var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsMicrophoneOutlineBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.85,50.17H70.36a20.36,20.36,0,0,1-40.72,0H25.15A24.87,24.87,0,0,0,47.76,74.91v6.6H38V86H62V81.51H52.25v-6.6A24.88,24.88,0,0,0,74.85,50.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50,65.37a14,14,0,0,0,14-14V28A14,14,0,0,0,36,28V51.4A14,14,0,0,0,50,65.37Zm0-4.49a9.49,9.49,0,0,1-9.48-9.48V34H59.48V51.4A9.49,9.49,0,0,1,50,60.88Zm0-42.39A9.48,9.48,0,0,1,59.48,28v1.56H40.53V28A9.49,9.49,0,0,1,50,18.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsMicrophoneOutlineBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_Microphone_Outline_Black_RGB.2b56d8ac599113ba7e1420f83b18b742.svg";
export { ForwardRef as ReactComponent };